import {
  WalletTotalPointRes,
  WalletTypePointRes,
  WalletStatRes,
  WalletPointLog,
  WalletConfigRes,
  BaseRes,
  WalletBase,
} from '../types';
import { create } from 'zustand';
import {
  getWalletConfig,
  getWalletStat,
  getWalletTotalPoints,
  getWalletTypePoints,
  postClaimtTypePoints,
  getWalletPointsLog,
} from '../services/home';

interface StoreState {
  walletConfig: WalletConfigRes;
  walletStat: WalletStatRes;
  walletTotalPoints: WalletTotalPointRes;
  walletTypePoints: WalletTypePointRes[];
  walletPointsLog: WalletPointLog[];
}

type Action = {
  fetchWalletConfig: () => Promise<WalletConfigRes | undefined>;
  fetchWalletStat: () => Promise<WalletStatRes | undefined>;
  fetchWalletTotalPoints: (
    data: WalletBase
  ) => Promise<WalletTotalPointRes | undefined>;
  fetchWalletTypePoints: (
    data: {
      type: number | string;
    } & WalletBase
  ) => Promise<BaseRes<WalletTypePointRes[]>>;
  doClaimtTypePoints: (data: {
    walletId: string;
    type: number;
  }) => Promise<Boolean | undefined>;
  fetchWalletPointsLog: (data: {
    walletId: string;
    page: number;
    size: number;
  }) => Promise<WalletPointLog[] | undefined>;
};

const useHomeStore = create<StoreState & Action>()(
  (
    set
    // get
  ) => ({
    walletConfig: {} as WalletConfigRes,
    walletStat: {} as WalletStatRes,
    walletTotalPoints: {} as WalletTotalPointRes,
    walletTypePoints: [],
    walletPointsLog: [],
    fetchWalletConfig: async () => {
      try {
        const res = await getWalletConfig();
        // console.log(res);
        if (res.success) {
          set(() => ({
            walletConfig: res.result || {},
          }));
          return res.result;
        }
      } catch (e) {
        console.error(e);
      }
    },
    fetchWalletStat: async () => {
      try {
        const res = await getWalletStat();
        // console.log(res);
        if (res.success) {
          set(() => ({
            walletStat: res.result || {},
          }));
          return res.result;
        }
      } catch (e) {
        console.error(e);
      }
    },
    fetchWalletTotalPoints: async (data: WalletBase) => {
      try {
        const res = await getWalletTotalPoints(data);
        // console.log('fetchWalletTotalPoints===>', res.message);
        if (res.success) {
          set(() => ({
            walletTotalPoints: res.result || {},
          }));
          return res.result;
        } else {
          return res;
        }
      } catch (e) {
        console.error(e);
      }
    },
    fetchWalletTypePoints: async (
      data: {
        type: number | string;
      } & WalletBase
    ) => {
      try {
        const res = await getWalletTypePoints(data);
        // console.log('fetchWalletTypePoints===>', res);
        if (res.success) {
          set(() => ({
            walletTypePoints: res.result || [],
          }));
        }
        return res;
      } catch (e) {
        console.error(e);
      }
    },
    doClaimtTypePoints: async (data: { type: number } & WalletBase) => {
      try {
        const res = await postClaimtTypePoints(data);
        if (res.success) {
          return res.success;
        }
      } catch (e) {
        console.error(e);
      }
    },
    fetchWalletPointsLog: async (data: {
      walletId: string;
      page: number;
      size: number;
    }) => {
      try {
        const res = await getWalletPointsLog(data);
        if (res.success) {
          set(() => ({
            walletPointsLog: res.result || [],
          }));
          return res.result;
        }
      } catch (e) {
        console.error(e);
      }
    },
  })
);

export default useHomeStore;
